/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Form_MaterialInputs */

const vi_aml_form_material = /** @type {(inputs: Aml_Form_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư`)
};

/**

* @param {Aml_Form_MaterialInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_form_material = /** @type {((inputs?: Aml_Form_MaterialInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Form_MaterialInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_form_material(inputs)
});